import buttonGenerator from './buttonGenerator';
export const Default = buttonGenerator('clearButton', 'default');
export const Primary = buttonGenerator('clearButton', 'primary');
export const Destructive = buttonGenerator('clearButton', 'destructive');
export const Safe = buttonGenerator('clearButton', 'safe');
export const Outline = buttonGenerator('clearButton', 'outline');
export const OutlinePrimary = buttonGenerator('clearButton', 'outlinePrimary');
export const OutlineBasic = buttonGenerator('clearButton', 'outlineBasic');
//# sourceMappingURL=ClearButton.js.map